const ENTER_KEY_CODE = 13;
const USER_TYPING_TIMEOUT = 200;

export default class FuzzySearch {
  constructor() {
    this.searchSidebarForm = $('.site-sidebar-search');
  }

  listenEvents() {
    this.searchSidebarForm.on('submit', e => {
      e.preventDefault();
      setTimeout(
        () => $('.site-sidebar').removeClass('in'),
        USER_TYPING_TIMEOUT
      );
    });

    this.searchSidebarForm.on('keypress', 'input', function(e) {
      if (e.which !== ENTER_KEY_CODE) return;

      $(this)
        .parent()
        .submit();
      return false;
    });
  }

  stopListening() {
    this.searchSidebarForm.off('submit');
    this.searchSidebarForm.find('input').off('keypress');
  }
}
